import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Header,
  Grid,
  Statistic,
  Segment
} from "semantic-ui-react";

import request from "../../utils/request";
import {formatInt, formatCurrency} from "../../utils/constants";
import { isNumber } from "lodash";

const resetState = props => {
  return {
    loading: true,
    pollInterval: false,
    event: {
      id: 0,
      title: "Loading event...",
      date: "dd/mm/yyyy"
    },
    summary: {
      tickets: 0,
      sales: 0,
      contributions: 0,
      expenses: 0,
      jackpot: 0,
      prize: 0,
      messages: 0,
      voids: 0
    }
  };
};

class EventTicker extends Component {
  constructor(props) {
    super(props);
    this.state = resetState(props);
  }
  componentDidMount = () => {
    this.pollData();
  };
  componentWillUnmount = () => {
    clearInterval(this.state.pollInterval);
    this.setState(resetState(this.props));
  };
  isLoaded = () => {
    this.setState({ loading: false });
  }
  pollData = () => {
    let self = this;
    let payload = {
      eventId: this.props.eventId
    };
    var getEvent;
    if (this.props.eventId === undefined || this.props.eventId === 0) {
      getEvent = request.get(this, "api:/event", {}).then(resp => {
        self.setState({
          event: resp
        });
        return resp;
      });
    } else {
      getEvent = request.get(this, `api:/event/${this.props.eventId}`, payload).then(resp => {
        self.setState({
          event: resp
        });
        return resp;
      });
    }
    getEvent
      .then(event => {
        request
          .get(this, `api:/event/${event.id}/summary`)
          .then(eventSummary => {
            self.setState({
              summary: {
                active: eventSummary.is_active,
                grossSets: eventSummary.sets.total,
                netSets: eventSummary.sets.net,
                totalTickets: eventSummary.tickets.total,
                netTickets: eventSummary.tickets.net,
                sales: eventSummary.sales.net,
                contributions: eventSummary.jackpot.contributions,
                expenses: eventSummary.expenses.total,
                jackpot: eventSummary.jackpot.jackpot,
                prize: eventSummary.jackpot.prize,
                messages: eventSummary.messages.unread,
                voids: eventSummary.tickets.voids,
                voidCount: eventSummary.sales.voidCount
              }
            }, self.isLoaded);
          });
        return event;
      })
      .then(event => {
        self.handlePoll(event);
        return true;
      });
  };
  handlePoll = resp => {
    if (resp.is_active === true) {
      if (!this.state.pollInterval) {
        let poll = setInterval(this.pollData, 30000);
        this.setState({
          pollInterval: poll
        });
      }
    }
  };
  render() {
    const { loading, event, summary } = this.state;
    return (
      <Segment inverted={summary.active ? true : false} raised={summary.active ? true : false} loading={loading} color="red">
        <Grid as={Link} to={`/events/${event.id}/summary`}>
          <Grid.Column mobile={16} tablet={6} computer={3}>
            <Header inverted={summary.active}>
              <u>{event.title}</u>
            </Header>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={10} computer={13}>
            <Statistic.Group size="mini" widths={11}>
              <Statistic
                inverted={summary.active}
                value={summary.messages}
                label="Messages"
              />
              <Statistic
                inverted={summary.active}
                value={summary.grossSets}
                label="Gross Sets"
              />
              <Statistic
                inverted={summary.active}
                value={summary.netSets}
                label="Net Sets"
              />
              <Statistic
                inverted={summary.active}
                value={summary.voidCount}
                label="Void Sets"
              />
              <Statistic
                inverted={summary.active}
                value={formatInt(summary.totalTickets)}
                label="Gross Numbers"
              />
              <Statistic
                inverted={summary.active}
                value={formatInt(summary.netTickets)}
                label="Net Numbers"
              />
              <Statistic
                inverted={summary.active}
                value={formatCurrency(summary.sales)}
                label="Net Sales"
              />
              <Statistic
                inverted={summary.active}
                value={formatCurrency(summary.expenses)}
                label="Expenses"
              />
              <Statistic
                inverted={summary.active}
                value={formatCurrency(summary.jackpot)}
                label={event.game_id == 3 ? "Progressive Jackpot" : "Jackpot"}
              />
              <Statistic
                inverted={summary.active}
                value={isNumber(summary.prize) ? formatCurrency(summary.prize) : (summary.prize.length > 15 ? summary.prize.substring(0, 12) + "..." : summary.prize)}
                title={isNumber(summary.prize) ? formatCurrency(summary.prize) : summary.prize}
                label={event.game_id == 3 ? "Weekly Prize" : "Prize"}
              />
            </Statistic.Group>
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
}

export default EventTicker;
